var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVacationIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0844 26.5315C17.8094 30.2215 17.7513 34.4386 19.6177 35.7271C19.7345 35.7855 19.8509 35.9028 19.9677 35.9612C20.7843 32.9743 21.9509 30.1627 23.5842 27.8201C23.7592 27.6444 23.8759 27.4687 24.0509 27.2342L24.4008 27.5856C24.1677 36.2537 22.4176 45.1563 20.3758 54.0002C21.9509 53.5316 23.7009 53.2387 25.5674 53.063C25.0425 46.0348 25.3924 36.6051 26.4422 27.7612C27.6088 30.3967 28.6004 33.6181 29.4756 37.0736C30.8172 35.4921 30.5254 31.5096 28.7172 27.2925C31.5171 28.3466 34.5505 29.9869 37.817 31.9193C37.7002 30.3966 36.0669 28.5806 33.442 26.9996C35.0171 27.5854 36.5918 28.2881 38.1669 29.1081C38.2251 28.9908 38.2837 28.8151 38.2837 28.6979C38.6922 26.4722 35.7169 23.6025 31.692 22.6653C33.8502 21.8453 36.2419 21.0838 38.8086 20.3227C37.467 19.2098 34.3754 19.2687 30.8753 20.4984C32.3336 19.2099 34.0251 18.0385 35.7752 17.0429C35.6584 16.9257 35.6002 16.8088 35.4834 16.75C33.7333 15.1685 29.3583 16.3986 26.3836 19.7957L25.9169 18.6828C23.9345 14.525 20.0262 12.2997 17.9262 13.3537C17.8094 13.4121 17.693 13.471 17.5763 13.5878C19.8512 15.8136 21.7762 18.2735 23.0597 20.909L22.7097 21.0846C21.7181 20.5576 20.5515 20.0306 19.3845 19.6204C14.601 17.9805 10.1097 18.0389 8.59296 19.6788C13.6678 20.3815 18.1595 21.3188 21.4262 22.9002L17.8679 24.833C12.9098 27.8202 10.0514 32.4471 11.2766 34.4971C11.3348 34.6144 11.4515 34.7312 11.5683 34.8485C13.8433 31.1585 16.76 28.2888 20.0847 26.5317L20.0844 26.5315Z",
    fill: "url(#paint0_linear_8677_44466)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.106 59.2087C43.4145 58.9746 41.8395 58.2715 40.4979 57.2175C39.5645 56.456 38.3979 55.8117 37.1146 55.2847C36.7061 55.109 36.298 54.9333 35.8894 54.8161C33.5563 54.0546 30.8145 53.5859 27.8979 53.5859C27.1394 53.5859 26.3813 53.6444 25.6811 53.7032C23.7562 53.8789 21.8897 54.2302 20.2564 54.7572C15.7647 56.163 12.7317 58.7986 12.7317 61.8443H62.3146L45.106 59.2087Z",
    fill: "url(#paint1_linear_8677_44466)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1528 42.99L28.136 42.4042C28.6609 42.2285 29.1858 42.2285 29.7111 42.4042L30.9944 42.7555C31.5193 42.9312 32.0442 42.9312 32.511 42.7555L33.8525 42.3454C34.3192 42.2281 34.8441 42.1697 35.3109 42.3454L35.8944 42.521V54.1763C36.3029 54.2935 36.711 54.4692 37.1196 54.6449L37.1191 42.8139C37.5859 42.9312 38.0526 42.8724 38.5192 42.6967L39.2191 42.4626C39.8026 42.2869 40.3857 42.2285 40.9692 42.4626L41.6691 42.6967C42.3108 42.8724 42.9524 42.8724 43.5941 42.6383C44.2357 42.3453 44.9356 42.3453 45.5773 42.5798L46.8606 43.0484C46.8606 39.827 42.2525 37.25 36.5356 37.25C30.8195 37.25 26.1527 39.7683 26.1527 42.9897L26.1528 42.99Z",
    fill: "url(#paint2_linear_8677_44466)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8677_44466",
    x1: 23.7008,
    y1: 4.91246,
    x2: 23.7008,
    y2: 54.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#397786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153D46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8677_44466",
    x1: 37.5231,
    y1: 51.9343,
    x2: 37.5231,
    y2: 61.8443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#397786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153D46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8677_44466",
    x1: 36.5067,
    y1: 33.771,
    x2: 36.5067,
    y2: 54.6449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#397786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153D46"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVacationIcon);
export default __webpack_public_path__ + "static/media/vacation_icon.797771d99e7258b513deb3af61d93e7b.svg";
export { ForwardRef as ReactComponent };